module.exports = __webpack_public_path__ + "ffe1c19bd5a92906204430ffd828bdb4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/frog-prince.png
// module id = 2529
// module chunks = 0